export enum BANK_ACCOUNT_ACTIONS {
  SET_BANK_ACCOUNT_LIST = 'BANK_ACCOUNT_ACTIONS.SET_BANK_ACCOUNT_LIST',
  SET_BANK_LIST = 'BANK_ACCOUNT_ACTIONS.SET_BANK_LIST',
  SET_BANK_ACCOUNT_DELETION = 'BANK_ACCOUNT_ACTIONS.SET_BANK_ACCOUNT_DELETION',
  DELETE_BANK_ACCOUNTS = 'BANK_ACCOUNT_ACTIONS.DELETE_BANK_ACCOUNT',
  SET_NEWLY_CREATED_BANK_ACCOUNT = 'BANK_ACCOUNT_ACTIONS.SET_NEWLY_CREATED_BANK_ACCOUNT',
}
